module.exports = __webpack_public_path__ + "img/bank-assets.24ecdd6c.svg";